export interface CurrencyProps {
  number: any;
  locales: string;
  style: string;
  currency: string;
}
export const Number = (props: CurrencyProps): JSX.Element => {
  const { number, locales, style, currency } = props;

  const formattedNumber = new Intl.NumberFormat(locales, {
    style: style,
    currency: currency,
  }).format(number);

  return <>{formattedNumber}</>;
};
